
export default {
  name: 'tabs',
  components: {},
  props: [],
  data() {
    return {tabs: [] };
},

created() {
    
    this.tabs = this.$children;
    
},
methods: {
    selectTab(selectedTab) {
        this.tabs.forEach(tab => {
            tab.isActive = (tab.name == selectedTab.name);
        });
    }
  }
}



